<template>
  <div class="profileWrapper contentPage">
    <div class="profile" v-if="userData">
      <div class="profile_title">
        Profile
      </div>
      <profile-block
          :photo="getPhoto(logo)"
          :name="getName"
          @updateEdit="onEditPassword(true)"
      ></profile-block>
      <profile-fields
          :email="email"
          :role="role"
      ></profile-fields>
      <profile-balance
          v-if="type === 2"
          :balance="balance"
          :totalCheck="total_check"
          :payments="payments"
      ></profile-balance>
    </div>
    <div v-if="isCustomers" class="managers">
      <div class="managers_title">Contacts</div>
      <div class="managers_block">
        <div
            v-for="manager in managerData"
            :key="manager.employee_id"
            class="managers_block-item"
        >
          <profile-block
              :photo="getPhoto(manager.logo)"
              :name="manager.name"
              :manager="manager"
          ></profile-block>
          <profile-fields
              :email="email"
              :role="role"
              :manager="manager"
          ></profile-fields>
        </div>
      </div>
    </div>
    <profile-edit-password
        v-if="isEditDrawer"
        @closeDrawer="onEditPassword(false)"
    ></profile-edit-password>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
// components
import ProfileBlock from "@/components/Profile/ProfileBlock/ProfileBlock";
import ProfileFields from "@/components/Profile/ProfileFields/ProfileFields";
import ProfileBalance from "@/components/Profile/ProfileBalance/ProfileBalance";
// services
import { getAppUrl } from "@/services";
// async components
const ProfileEditPassword = () => import("@/components/Profile/ProfileEditPassword/ProfileEditPassword");

export default {
	name: "Profile",
	components: {
		ProfileBlock,
		ProfileFields,
		ProfileBalance,
		ProfileEditPassword
	},
	computed: {
		...mapGetters([ 'userData', 'managerData', 'isCustomers' ]),
		getName() {
			if (this.type === 2) return this.customer ?? this.name;
			return this.dispatcher ?? this.name;
		}
	},
	data: () => ({
		isEditDrawer: false,
		role: null,
		email: null,
		logo: null,
		name: null,
		dispatcher: null,
		customer: null,
		type: null,
		total_check: null,
		balance: null,
		payments: null,
	}),
	methods: {
		...mapActions([ 'getUser' ]),
		onEditPassword(value) {
			this.isEditDrawer = value;
		},
		getPhoto(logo) {
			if (logo) {
				return getAppUrl + logo;
			}

			return '';
		},
	},
	async mounted() {
		await this.getUser();

		if (this.userData) {
			for (const key in this.userData) {
				this[key] = this.userData[key];
			}
		}
	},
};
</script>
<style lang="scss" scoped>
@import "profile";
</style>
